<template>
  <div>
    <table style="width: 100%;">
      <tr>
        <th></th>
        <th :style="`font-size: 0.9em; text-align: end; ${getPartyStyle('gop')};`">GOP</th>
        <th :style="`font-size: 0.9em; text-align: end; ${getPartyStyle('dem')};`">Dem</th>
      </tr>
      <tr>
        <td class="mobile-scoreboard-key">Funds</td>
        <td class="scoreboard-value mobile-value" :style="getScoreStyle('gop', favored ? fundsRemaining.gop : initial.gop.funds)">
          {{ favored ? fundsRemaining.gop : initial.gop.funds | money }}
        </td>
        <td class="scoreboard-value mobile-value" :style="getScoreStyle('dem', favored ? fundsRemaining.dem : initial.dem.funds)">
          {{ favored ? fundsRemaining.dem : initial.dem.funds | money }}
        </td>
      </tr>
      <tr>
        <td class="mobile-scoreboard-key">Favored Seats</td>
        <td class="scoreboard-value mobile-value" :style="getScoreStyle('gop')">
          <span
            :style="`color: ${favored.gop.negative ? '#FA3138;' : '#57AEA6;'}`"
            v-if="favored && favored.gop.change !== 0">
            ( <template v-if="!favored.gop.negative">+</template>
            {{ favored.gop.change }} )
          </span>
          {{ favored ? favored.gop.seats : initial.gop.favored }}
        </td>
        <td class="scoreboard-value mobile-value" :style="getScoreStyle('dem')">
          <span
            :style="`color: ${favored.dem.negative ? '#FA3138;' : '#57AEA6;'}`"
            v-if="favored && favored.dem.change !== 0">
            ( <template v-if="!favored.dem.negative">+</template>
            {{ favored.dem.change }} )
          </span>
          {{ favored ? favored.dem.seats : initial.dem.favored }}
        </td>
      </tr>
      <tr>
        <td class="mobile-scoreboard-key">Expected Seats</td>
        <td class="scoreboard-value mobile-value" :style="getScoreStyle('gop')">
          <span
            :style="`color: ${expected.gop.negative ? '#FA3138;' : '#57AEA6;'}`"
            v-if="expected && expected.gop.change !== 0">
            ( <template v-if="!expected.gop.negative">+</template>
            {{ Math.round(expected.gop.change) }} )
          </span>
          {{ expected ? Math.round(expected.gop.seats) : initial.gop.expected }}
        </td>
        <td class="scoreboard-value mobile-value" :style="getScoreStyle('dem')">
          <span
            :style="`color: ${expected.dem.negative ? '#FA3138;' : '#57AEA6;'}`"
            v-if="expected && expected.dem.change !== 0">
            ( <template v-if="!favored.dem.negative">+</template>
            {{ Math.round(expected.dem.change) }} )
          </span>
          {{ expected ? Math.round(expected.dem.seats) : initial.dem.expected }}
        </td>
      </tr>
    </table>

    <v-divider style="margin: 10px 0"></v-divider>

    <div class="mobile-scoreboard-key">Total Spendings</div>
    <div class="ml-2">
      <span :style="`font-size: 0.8em; text-align: end; ${getPartyStyle('gop')};`">GOP</span> :
      <span class="scoreboard-value mobile-value" :style="getScoreStyle('gop')">
        {{ favored ? totalSpend.gop : initial.gop.totalSpend | money }}
      </span>
    </div>
    <div class="ml-2">
      <span :style="`font-size: 0.8em; text-align: end; ${getPartyStyle('dem')};`">Dem</span> :
      <span class="scoreboard-value mobile-value" :style="getScoreStyle('dem')">
        {{ favored ? maxSpend.gop : initial.gop.maxSpend | money }}
      </span>
    </div>

    <div class="mobile-scoreboard-key mt-2">Max Spendings</div>
    <div class="ml-2">
      <span :style="`font-size: 0.8em; text-align: end; ${getPartyStyle('gop')};`">GOP</span> :
      <span class="scoreboard-value mobile-value" :style="getScoreStyle('gop')">
        {{ favored ? totalSpend.dem : initial.dem.totalSpend | money }}
      </span>
    </div>
    <div class="ml-2">
      <span :style="`font-size: 0.8em; text-align: end; ${getPartyStyle('dem')};`">Dem</span> :
      <span class="scoreboard-value mobile-value" :style="getScoreStyle('dem')">
        {{ favored ? maxSpend.dem : initial.dem.maxSpend | money }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const props = ['totalSpend', 'maxSpend', 'fundsRemaining', 'favored', 'expected']

const computed = {
  ...mapGetters({
    chamber: 'calculator/chamber',
    mode: 'calculator/mode',
    mobile: 'ux/mobile'
  }),
  initial () {
    if (this.chamber) {
      return {
        gop: {
          funds: 0,
          favored: this.chamber === 'house' ? 207 : 50,
          expected: this.chamber === 'house' ? 203 : 52,
          totalSpend: this.chamber === 'house' ? 255887142 : 510862916,
          maxSpend: this.chamber === 'house' ? 255887142 : 510862916
        },
        dem: {
          funds: 0,
          favored: this.chamber === 'house' ? 228 : 50,
          expected: this.chamber === 'house' ? 232 : 48,
          totalSpend: this.chamber === 'house' ? 325290696 : 783714990,
          maxSpend: this.chamber === 'house' ? 325290696 : 783714990
        }
      }
    }
  }
}

const methods = {
  getPartyStyle (party) {
    if (this.mode === 'god' || party === this.mode) {
      return party === 'republican' ? 'color: #FA3138; font-weight: 500;' : 'color: #66ABCF; font-weight: 500;'
    } else {
      return 'color: #666; font-weight: 400;'
    }
  },
  getScoreStyle (party, funds) {
    let styles = ''
    if (this.mode === 'god' || party === this.mode) {
      styles += 'color: #333; font-weight: 500;'
    } else {
      styles += 'color: #333; font-weight: 400;'
    }

    if (funds && funds > 0) {
      styles += 'color: #57AEA6;'
    } else if (funds && funds < 0) {
      styles += 'color: #FA3138;'
    }
    return styles
  }
}

export default {
  props,
  computed,
  methods
}
</script>

<style>
.mobile-scoreboard-key {
  color: #666;
  font-weight: 400;
  font-size: 0.8em;
  letter-spacing: 0.03em;
  text-align: start;
  /* text-transform: lowercase; */
}

.mobile-value {
  font-size: 0.85em !important;
  text-align: end !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/calculator/ScoreboardMobile.vue